export const MAGIC_LINK_TOKEN_COOKIE_NAME = 'mlt'
export const ACCOUNT_SESSION_TOKEN_COOKIE_NAME = 'PulseSessionToken'

export const BASIN_SESSION_ID_COOKIE_NAME = 'BasinSessionId'
export const INSCALAR_SESSION_ID_COOKIE_NAME = 'InscalarSessionId'
